module.exports = __webpack_public_path__ + "static/media/brand-car-wreck-sunnybank.0ed590c6.png";